var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileItemDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2486 12.5001L16.8448 8.90382C17.0517 8.69682 17.0517 8.36225 16.8448 8.15525C16.6378 7.94825 16.3032 7.94825 16.0962 8.15525L12.5 11.7515L8.90381 8.15525C8.69681 7.94825 8.36224 7.94825 8.15525 8.15525C7.94825 8.36225 7.94825 8.69682 8.15525 8.90382L11.7514 12.5001L8.15525 16.0963C7.94825 16.3033 7.94825 16.6379 8.15525 16.8449C8.25848 16.9481 8.394 17 8.52953 17C8.66505 17 8.80057 16.9481 8.90381 16.8449L12.5 13.2486L16.0962 16.8449C16.1994 16.9481 16.3349 17 16.4705 17C16.606 17 16.7415 16.9481 16.8447 16.8449C17.0517 16.6379 17.0517 16.3033 16.8447 16.0963L13.2486 12.5001Z",
    fill: "#96008F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileItemDelete);
export default __webpack_public_path__ + "static/media/mobileItemDelete.009db6e41a519da4b8fe05d38c25ef8f.svg";
export { ForwardRef as ReactComponent };